import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { useLocation } from "react-router-dom";

import Loading from "web/Layout/Common/Loading";

import urls from "web/constants/urls";

import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";

import MainHeaderDashboard from "./MainHeaderDashboard";
import MainHeaderDefault from "./MainHeaderDefault";

const MobileMainHeader = () => {
  const { pathname } = useLocation();
  const { data: company, isLoading } = useGetCompanyDetailsQuery();
  const hasDashboardHeaderEnabled = company?.enableDashboardHeader;
  const isDashboardMenuEnabled = useFeatureIsOn("pwa_dashboard_menu");

  const isLandingPage =
    pathname?.indexOf("/lp/") !== -1 || pathname === urls.multisport;

  if (isLoading) {
    return <Loading />;
  }

  if (hasDashboardHeaderEnabled && isDashboardMenuEnabled) {
    return <MainHeaderDashboard />;
  }

  if (pathname !== urls.home && !isLandingPage) {
    return null;
  }

  return <MainHeaderDefault />;
};

export default MobileMainHeader;
